import { ENDPOINTS } from '@/feat/api-service-layer/endpoints';
import { BASE_URL } from '@/feat/api-service-layer/fetchClient';
import type { UserConfig } from '@/types/auth';

export interface UserSettingsResponse {
  settings: Record<string, unknown>;
  subscription_type: string;
  expiration_timestamp: number;
  customer_id: string;
}

export interface UserDataWithConfig {
  idToken: {
    jwtToken: string;
    payload?: {
      name?: string;
      email?: string;
      exp?: number;
      auth_time?: number;
      [key: string]: unknown;
    };
  };
  accessToken?: {
    jwtToken: string;
    payload?: Record<string, unknown>;
  };
  refreshToken?: {
    token: string;
  };
  config: UserConfig;
  [key: string]: unknown;
}

export const fetchUserSettings = async (token: string): Promise<UserSettingsResponse> => {
  const response = await fetch(`${BASE_URL}${ENDPOINTS.userSettings}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch user settings: ${response.status} ${response.statusText}`);
  }

  return response.json();
};

export const isSubscriptionExpired = (expirationTimestamp: number): boolean => {
  const expirationDate = new Date(expirationTimestamp * 1000);
  return expirationDate.getTime() < Date.now();
};
